import React, { useState } from "react";
import workspaces from "../../assets/icons/workspace_main.svg";
import user from "../../assets/images/user.png";
import ToggleButton from "../../components/ToggleButton";
import PrimaryButton from "../../components/PrimaryButton";
import MainModal from "../../components/MainModal";
import AllVoicesModal from "../../components/AllVoicesModal";
import TranslateToModal from "../../components/TranslateToModal";
import SearchBar from "../../components/SearchBar";
import { FaPlus } from "react-icons/fa6";
import { Voice } from "../../components/SelectVoice";
import AddOwnVoiceModal from "../../components/AddOwnVoiceModal";
import AddNewMemberToWorkspaceModal from "../../components/AddNewMemberToWorkspaceModal";
import { RiUserSettingsLine } from "react-icons/ri";
import DotMenu from "../../components/DotMenu";
import { PiTrashLight } from "react-icons/pi";
import { useRedirect } from "../../hooks/useRedirect";
import pathnames from "../../routes/index.route";
import YourBalance from "../../components/YourBalance";
import TopUp from "../../components/TopUp";
import PaymentHistory from "../../components/PaymentHistory";
import { BoldPencilIcon, BoldRightArrowIcon } from "../../assets/icons/Icons";
import { ActionBothProps } from "../../types/common";

interface voiceProps extends ActionBothProps {
  showAddOwnVoice?: () => void;
}

const Voices = ({ showPrev, showNext, showAddOwnVoice }: voiceProps) => {
  return (
    <>
      <p className="text-[#9392A2] text-sm font-medium leading-snug tracking-normal">You can sync content all across your <br />profiles in terms of account group.</p>
      <SearchBar className="bg-white mt-3" inputCss="text-xs" placeholder="Search voices" />
      <p className="text-[#9392A2] text-xs mt-5 mb-3 font-medium tracking-tight">My voices</p>
      <div onClick={() => showAddOwnVoice && showAddOwnVoice()} className="px-3 py-2 rounded-xl bg-white mb-2 cursor-pointer">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 border border-[#9392A2] border-dashed rounded-full">
            <FaPlus />
          </div>
          <div className="text-[#9392A2] text-base font-medium tracking-tight">Add your voice</div>
        </div>
      </div>
      <Voice />
      <p className="text-[#9392A2] text-xs mt-5 mb-3 font-medium tracking-tight">System voices</p>
      <Voice />
      <Voice />
      <Voice />
      <div className="flex items-center gap-2 mt-2">
        <PrimaryButton onClick={() => showPrev && showPrev()} className="py-2 text-sm rounded-3xl w-full" label="Back" black />
        <PrimaryButton onClick={() => showNext && showNext()} className="py-2 text-sm rounded-3xl w-full" label="Confirm"  />
      </div>
    </>
  );
}

const userDotMenu = [
  {label: "Manage access", icon: RiUserSettingsLine},
  {label: "Remove user", icon: PiTrashLight, color: "red"},
]

const WorskpacesSettings = () => {
  const [showVoice, setShowVoice] = useState<boolean>(false);
  const [showLinkVoice, setShowLinkVoice] = useState<boolean>(false);
  const [showSyncVoices, setShowSyncVoices] = useState<boolean>(false);
  const [showAddOwnVoice, setShowAddOwnVoice] = useState<boolean>(false);
  const [showAddNewMember, setShowAddNewMember] = useState<boolean>(false);
  const [showBalance, setShowBalance] = useState<boolean>(false);
  const [showTopUp, setShowTopUp] = useState<boolean>(false);
  const [showPayHistory, setShowPayHistory] = useState<boolean>(false);
  const redirect = useRedirect();
  return (
    <>
      <div className="flex gap-2 flex-wrap">
        <div className="w-[380px]">
          <p className="text-[#9392A2] text-xs font-medium tracking-tight mb-3">General settings</p>
          <div className="w-full bg-white rounded-xl p-3 mb-2">
            <div className="flex items-center justify-between">
              <p className="text-[#9392A2] text-xs font-medium tracking-tight">Workspace picture</p>
              <BoldPencilIcon />
            </div>
            <img className="w-14 h-14 mt-1 rounded-full" src={workspaces} alt="user" />
          </div>
          <div className="w-full bg-white rounded-xl p-3 mb-2 flex items-center justify-between">
            <div>
              <p className="text-[#9392A2] text-xs font-medium tracking-tight">Name</p>
              <p className="text-neutral-900 text-sm font-medium tracking-tight">Andrew’s workspace</p>
            </div>
            <BoldPencilIcon />
          </div>
          <p className="text-[#9392A2] text-xs font-medium tracking-tight mt-6 mb-3">Payment & plans</p>
          <div className="w-full bg-white rounded-xl p-3 mb-2 flex items-center justify-between">
            <div>
              <p className="text-[#9392A2] text-xs font-medium tracking-tight">Your plan</p>
              <p className="text-neutral-900 text-sm font-medium tracking-tight">Solo</p>
            </div>
              <PrimaryButton onClick={() => redirect(pathnames.settings+pathnames.UpgradePlan)} label="Upgrade" className="py-2 rounded-3xl px-5 text-sm" />
          </div>
          <div className="w-full bg-white rounded-xl p-3 mb-2 flex items-center justify-between">
            <div>
              <p className="text-[#9392A2] text-xs font-medium tracking-tight">Balance</p>
              <p className="text-neutral-900 text-sm font-medium tracking-tight">$ 1,345.92</p>
            </div>
              <BoldRightArrowIcon onClick={() => setShowBalance(true)} />
          </div>
          <div className="w-full bg-white rounded-xl p-3 mb-2 flex items-center justify-between">
            <div>
              <p className="text-[#9392A2] text-xs font-medium tracking-tight">General history</p>
              <p className="text-neutral-900 text-sm font-medium tracking-tight">Translation of 5 files: – $25</p>
            </div>
              <BoldRightArrowIcon onClick={() => setShowPayHistory(true)} />
          </div>
        </div>
        <div className="w-[380px]">
          <p className="text-[#9392A2] text-xs font-medium tracking-tight mb-3">Other</p>
          <div className="w-full bg-white rounded-xl p-3 mb-2 flex items-center justify-between">
            <div>
              <p className="text-[#9392A2] text-xs font-medium tracking-tight">All voices</p>
              <p className="text-neutral-900 text-sm font-medium tracking-tight">Manage all your voices</p>
            </div>
            <BoldRightArrowIcon onClick={() => setShowVoice(true)} />
          </div>
          <div className="w-full bg-white rounded-xl p-3 mb-2 flex items-center justify-between">
            <div>
              <p className="text-[#9392A2] text-xs font-medium tracking-tight">Default voice</p>
              <p className="text-neutral-900 text-sm font-medium tracking-tight">Set up for different languages</p>
            </div>
            <BoldRightArrowIcon onClick={() => setShowLinkVoice(true)}/>
          </div>
          <div className="w-full bg-white rounded-xl p-3 mb-2 flex items-center justify-between">
            <div>
              <p className="text-[#9392A2] text-xs font-medium tracking-tight">Inviting</p>
              <p className="text-neutral-900 text-sm font-medium tracking-tight">Disable inviting by guests</p>
            </div>
              <ToggleButton/>
          </div>
          <div className="w-full bg-white rounded-xl p-3 mb-2 flex items-center justify-between">
            <div>
              <p className="text-[#9392A2] text-xs font-medium tracking-tight">Log out</p>
              <p className="text-neutral-900 text-sm font-medium tracking-tight">Log out all users</p>
            </div>
            <BoldRightArrowIcon />
          </div>
        </div>
        <div className="w-[380px]">
          <p className="text-[#9392A2] text-xs font-medium tracking-tight mb-3">5 profiles</p>
          {
            [...Array(5)].map((_, index) => (
              <div key={index} className="w-full bg-white rounded-xl p-3 mb-2 flex items-center justify-between gap-3">
                <div className="flex items-center gap-2.5">
                  <img className="w-10 h-10 rounded-full" src={user} alt="user" />
                  <div>
                    <p className="text-[#0F0C18] text-base font-medium tracking-tight">Andrew Wack</p>
                    <p className="text-[#9392A2] text-xs font-medium tracking-tight">andrew@mail.com</p>
                  </div>
                </div>
                <div className="flex items-center gap-2.5">
                  <p className="text-zinc-400 text-xs font-medium tracking-tight">Owner</p>
                  <DotMenu options={userDotMenu} />
                </div>
              </div>
            ))
          }
        </div>
      </div>
      {
        showVoice &&
        <MainModal
          label="All voices"
          setShowModal={setShowVoice}
        >
          <AllVoicesModal />
        </MainModal>
      }
      {
        showLinkVoice &&
        <MainModal
          label="Link voice & language"
          setShowModal={setShowLinkVoice}
        >
          <TranslateToModal subTitle="You can sync voices to your languages." showNext={() => {
            setShowLinkVoice(false);
            setShowSyncVoices(true);
          }}
          />
        </MainModal>
      }
      {
        showSyncVoices && 
        <MainModal
          label="Voices"
          setShowModal={setShowSyncVoices}
        >
          <Voices
            showPrev={() => {
              setShowSyncVoices(false);
              setShowLinkVoice(true);
            }}
            showAddOwnVoice={() => {
              setShowSyncVoices(false);
              setShowAddOwnVoice(true);
            }} />
        </MainModal>
      }
      {
        showAddOwnVoice && 
        <MainModal
          label="Add own voice"
          setShowModal={setShowAddOwnVoice}
        >
          <AddOwnVoiceModal
            showPrev={() => {
              setShowAddOwnVoice(false);
              setShowSyncVoices(true);
            }}
            showNext={() => {
              setShowAddOwnVoice(false);
              setShowSyncVoices(true);
            }}
          />
        </MainModal>
      }
      {/* need to attach this bottom modal */}
      {
        showAddNewMember && 
        <MainModal
          label="New member"
          setShowModal={setShowAddNewMember}
        >
          <AddNewMemberToWorkspaceModal />
        </MainModal>
      }
      {
        showBalance && 
        <MainModal
          subLabel="Your  balance"
          setShowModal={setShowBalance}
        >
          <YourBalance showTopUp={() => {
            setShowBalance(false);
            setShowTopUp(true)
          }} />
        </MainModal>
      }
      {
        showTopUp && 
        <MainModal
          label="Top up"
          setShowModal={setShowTopUp}
        >
          <TopUp showPrev={() => {
            setShowTopUp(false)
            setShowBalance(true);
          }} />
        </MainModal>
      }
      {
        showPayHistory && 
        <MainModal
          label="Payment history"
          setShowModal={setShowPayHistory}
        >
          <PaymentHistory />
        </MainModal>
      }
    </>
  );
};

export default WorskpacesSettings;